export const defaultPageSize = 10;

export const constants = {
  assets: () => [...constants.default(), "assets"] as const,
  default: () => ["orders"] as const,
  detail: (id: string) => [...constants.default(), "details", id] as const,
  documentsCount: (period: string) =>
    [...constants.default(), "documents-count", period] as const,
  list: <T extends Record<string, any>>(params?: T) =>
    [...constants.default(), "list", ...(params ? [params] : [])] as const,
  recalculate: (id: string) =>
    [...constants.default(), "recalculate", id] as const,
};
